import { Spinner } from '@shared/components/spinner';

export const Signup: React.FC = () => (
  <div className="w-full h-full grid items-center justify-center">
    <div className="pointer-events-auto w-full max-w-sm overflow-hidden bg-white shadow-lg ring-1 ring-black/5 grid grid-flow-col items-center justify-center gap-2 border rounded-sm pl-3 pr-1 py-3">
      <span className="text-lg font-medium text-gray-900">Redirecting...</span>
      <Spinner sizeClass="w-8 h-8" />
    </div>
  </div>
);
